import React from "react";
import { createFileRoute } from "@tanstack/react-router";
//
import { useTranslation } from "react-i18next";
import { Center, Stack } from "@mantine/core";
import {
  SpringOnboardingText,
  SpringOnboardingTitle,
} from "@components/Typography";

export const Route = createFileRoute("/spring-health/thank-you")({
  component: SpringHealthThanksPage,
});

function SpringHealthThanksPage(): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Stack align="center" gap="md" mt="xl" px="lg">
      <SpringOnboardingTitle order={2}>Thank you!</SpringOnboardingTitle>

      <Center mt="md" w={{ xs: "100%", md: "60%" }}>
        <Stack>
          <SpringOnboardingText data-testid="enroll-success-text">
            {t("springHealth.thankYouPage.mainCopy")}
          </SpringOnboardingText>

          <SpringOnboardingText>
            {t("springHealth.thankYouPage.playerCopy")}
          </SpringOnboardingText>
        </Stack>
      </Center>
    </Stack>
  );
}
